/*
|-------------------------------------------------------------------------------
| VUEX modules/bookings.js
|-------------------------------------------------------------------------------
| The Vuex data store for the cafes

status = 0 -> data hasn't been loaded
status = 1 -> data is loading
status = 2 -> data is loaded successfully
status = 3 -> data is loaded unsuccessfully
*/

import ManifestApi from '../api/manifest.js';

export const manifests = {
    state: {
        manifestBookings: [],
        manifestBookingsLoadStatus: 0,
        currentBookings: [],
        futureBookings: [],
        oldBookings: [],
        filtered: false,
        headerLocation: [],
        headerLocationLoadStatus: 0,
    },

    actions: {
        loadManifestBookings( { commit } ){
            commit( 'setManifestBookingsLoadStatus', 1 );

            ManifestApi.getBookings()
                .then( function( response ){
                    
                    commit( 'setCurrentBookings', response.data.current.data );
                    commit( 'setFutureBookings', response.data.future.data );
                    commit( 'setOldBookings', response.data.old.data );

                    commit( 'setManifestBookingsLoadStatus', 2 );
                })
                .catch( function(){
                    // commit( 'setManifestBookings', [] );
                    // commit( 'setManifestBookingsLoadStatus', 3 );
                });
        },
        updateHeaderLocation({ state, commit, rootState}, newLocation){
            commit('setHeaderLocationLoadStatus', 1);

            let findLocation = rootState.locations.pickupLocations.find(location => location.id === newLocation);
            commit( 'setHeaderLocation', findLocation );

            commit('setHeaderLocationLoadStatus', 2);
        },
        filterBookings({commit, dispatch}, data){
            commit( 'setManifestBookingsLoadStatus', 1 );
            dispatch('updateHeaderLocation', data.location);
            ManifestApi.filterBookings(data)
                .then(function (response) {
                    commit( 'setCurrentBookings' , response.data.data);

                    commit( 'setFutureBookings', [] );
                    commit( 'setOldBookings', [] );
                    commit( 'setFiltered', true );
                    commit( 'setManifestBookingsLoadStatus', 2 );
                });
        }
    },

    mutations: {
        setManifestBookingsLoadStatus( state, status ){
            state.manifestBookingsLoadStatus = status;
        },
        setManifestBookings( state, bookings ){
            state.manifestBookings = bookings;
        },
        setCurrentBookings(state, bookings){
            state.currentBookings = groupBy(bookings.map(res => mapToBooking(res)));
        },
        setFutureBookings(state, bookings){
            state.futureBookings = groupBy(bookings.map(res => mapToBooking(res)));
        },
        setOldBookings(state, bookings){
            state.oldBookings = groupBy(bookings.map(res => mapToBooking(res)));
        },
        setFiltered(state, status){
            state.filtered = status;
        },
        setHeaderLocation(state, location){
            state.headerLocation = location;
        },
        setHeaderLocationLoadStatus(state, status){
            state.headerLocationLoadStatus = status;
        }
    },

    getters: {
        getManifestBookingsLoadStatus( state ){
            return state.manifestBookingsLoadStatus;
        },
        getManifestBookings( state ){
            return state.manifestBookings;
        },
        getFutureBookings(state){
            return state.futureBookings;
        },
        getCurrentBookings(state){
            return state.currentBookings;
        },
        getOldBookings(state){
            return state.oldBookings;
        },
        getFiltered(state){
            return state.filtered;
        },
        getHeaderLocation(state){
            return state.headerLocation;
        },
        getHeaderLocationLoadStatus(state){
            return state.headerLocationLoadStatus;
        }
    }
};

/**
 * Helpers
 */

function mapToBooking (res) {
    let booking = {
        carrierName: res.carrier,
        carrierId: res.carrier_id,
        customer: res.customer,
        deliveryAddress: res.delivery_address,
        number: res.number,
        id: res.id,
        lines: res.lines.data.map((line) => mapToLine(line)),
        quantity: res.quantity,
        reference: res.reference,
        region: res.region,
        volume: res.volume,
        weight: res.weight,
    };
    
    return booking;
}

function mapToLine(data) {
    return {
        key: data.id,
        id: data.id,
        description: data.description,
        dgLines: data.dgLines,
        goodsType: data.goodsType,
        packageType: data.packageType,
        quantity: data.quantity,
        volume: data.volume,
        weight: data.weight,
    }
}

function groupBy(array){
            const result = {}

            array.forEach(item => {
                if (!result[item['carrierName']]){

                    result[item['carrierName']] = []
                }

                result[item['carrierName']].push(item)
            })
            
            return result
}